import {AxiosInstance, AxiosPromise, AxiosRequestConfig} from 'axios'
import {
  ContentListRequestParam,
  FileInfo,
  ItemsResponse,
  ListResponse,
  MessageAction,
  QiniuFileInfo
} from '/@src/models/api'
import { getFileExtension } from '/@src/utils'
import {MediaFile, MediaMeta} from "/@src/models/content";

export function getUploadToken(
  api: AxiosInstance,
  file: File,
  bucket?:string
): Promise<FileInfo> {
  const data: AxiosRequestConfig = {
    params: {
      bucket: bucket,
      file_extension: getFileExtension(file),
      full_file_name: file.name,
    },
  }
  return api.get('/v1/radio/qiniu/token', data)
}

export function fetchFileMeta(
  api: AxiosInstance,
  key: string
): Promise<MediaMeta> {
  const data: AxiosRequestConfig = {
    params: {
      key: key
    }
  }
  return api.get('/v1/radio/qiniu/filemeta', data)
}


export function createMedia(
  api: AxiosInstance,
  title: string,
  file_uri: string
): Promise<MediaFile> {
  const data={
    title: title,
    file_uri: file_uri
  }
  return api.post('/v1/admin/media/quick', data)
}
export function getQiniuFileInfo(
  api: AxiosInstance,
  url: string
): Promise<QiniuFileInfo> {
  return api.get(url+'?avinfo')
}
export function getMediaList(
  api: AxiosInstance,
  param:ContentListRequestParam,
  isReport:boolean
): Promise<ListResponse<MediaFile>> {
  const data: AxiosRequestConfig = {
    params: {
      limit: param.limit,
      page: param.page,
      keyword: param.keywords,
      author_id: param.userId,
      only_research:isReport
    },
  }
  return api.get('/v1/admin/media', data)
}

export const deleteMedia = (api: AxiosInstance,id:number):AxiosPromise => {
  return api.delete('/v1/admin/media/'+id)
}

export const editMedia = (api: AxiosInstance,file:MediaFile):AxiosPromise => {
  return api.put(`/v1/admin/media/${file.id}`,file)
}
